import React from "react";
import styled, { css } from "styled-components";
import { px2rem } from "utils/browser/resizer";
import Constant, {
	CountryIConPosition,
	setCookie,
	Host,
	comCookieLocal,
} from "utils/headFootConstants";

import getLangKeyValueFun from "utils/lang";
import { AssetImageUrl } from "assets/imgUrls";
import langGroup from "assets/lang.json";
import { CountryInfo } from "headFootServices/header/header";
import { Color } from "config/index";

const gettext = getLangKeyValueFun(langGroup);

const Container = styled.div`
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	z-index: 3000;
	background: #ffffff;
	font-size: ${px2rem(16)};
	color: #333333;
	padding-top: ${px2rem(106)};
	box-sizing: border-box;
`;
const Header = styled.div`
	position: fixed;
	top: 0;
	width: 100%;
	height: ${px2rem(50)};
	padding: 0 ${px2rem(13.5)};
	box-sizing: border-box;
	z-index: 10;
	> div {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;
const List = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: scroll;
	background: #fff;
	padding-bottom: ${px2rem(105)};
	box-sizing: border-box;
`;
const Close = styled.div`
	position: absolute;
	top: 50%;
	left: ${px2rem(12)};
	transform: translateY(-50%);
`;
const Title = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-weight: 800;
	font-size: ${px2rem(18)};
`;
const Search = styled.div`
	position: fixed;
	top: ${px2rem(50)};
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 ${px2rem(13.5)};
	color: #333;
	font-size: ${px2rem(14)};
	margin-bottom: ${px2rem(17)};
	z-index: 10;
	box-sizing: border-box;
`;
const SearchInput = styled.div`
	flex: 1;
	position: relative;
	> input {
		border: none;
		width: 100%;
		background: #f0f0f0;
		border-radius: 0.375rem;
		padding: 0 1.625rem 0 2.125rem;
		height: 2.0625rem;
		box-sizing: border-box;
		tap-highlight-color: transparent;
		-webkit-tap-highlight-color: transparent;
		outline: none;
	}
	> img {
		position: absolute;
		left: 0.5625rem;
		top: 0.5rem;
	}
`;
const Cancel = styled.div`
	margin-left: ${px2rem(13.5)};
`;
const CountryTitle = styled.div`
	padding: 0 ${px2rem(13.5)};
	font-size: ${px2rem(16)};
	font-weight: 700;
`;
const LetterTitle = styled(CountryTitle)`
	padding: 0 ${px2rem(13.5)};
	font-size: ${px2rem(16)};
	font-weight: 700;
	height: ${px2rem(50)};
	line-height: ${px2rem(50)};
`;
const CountryItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: ${px2rem(50)};
	margin-left: ${px2rem(13.5)};
	padding-right: ${px2rem(13.5)};
	> img {
		display: none;
	}
	${(props: { checked?: boolean; noBorderBottom?: boolean }) =>
		props.checked &&
		css`
			color: ${Color.Main};
			> img {
				display: block;
			}
		`};
	${(props: { checked?: boolean; noBorderBottom?: boolean }) =>
		!props.noBorderBottom &&
		css`
			border-bottom: 1px solid #dedede;
		`};
`;
const ItemLeft = styled.div`
	display: flex;
	align-items: center;
	> em {
		width: ${px2rem(40)};
		font-style: normal;
	}
`;
const CountryIcon = styled.div`
	width: ${px2rem(24)};
	height: ${px2rem(16)};
	background-image: url(https://lijc.rightinthebox.com/jupiter_lightsource/img/icon_header_country_flag.png);
	background-repeat: no-repeat;
	margin-right: ${px2rem(13.5)};
	background-position: 100px 100px;
`;
interface CountryProps {
	countries: CountryInfo[];
	popularCountries: CountryInfo[];
	currentCountry: CountryInfo;
	stateChange: (key, value) => void;
}
interface CountryState {
	showCancel: boolean;
	searchText: string;
	allCountry: CountryInfo[];
	filterList: CountryInfo[];
}
class Country extends React.Component<CountryProps, CountryState> {
	constructor(props) {
		super(props);
		const { countries = [], popularCountries = [] } = props;
		this.state = {
			showCancel: false,
			searchText: "",
			allCountry: [...countries, ...popularCountries],
			filterList: [],
		};
	}
	// 输入搜索文字
	searchInput = (e) => {
		this.setState(
			{
				searchText: e.target.value || "",
			},
			() => {
				if (this.state.searchText) {
					this.searchCountry(this.state.searchText);
				}
			},
		);
	};
	// 本地搜索国家
	searchCountry = (value) => {
		const { countries = [] } = this.props;
		const filterList = countries.filter((item) => {
			const searchIndex = item.countryName
				.toLocaleLowerCase()
				.indexOf(value.toLocaleLowerCase());
			if (searchIndex === 0) {
				return true;
			}
		});
		this.setState({ filterList });
	};

	cancel = () => {
		this.setState({
			showCancel: false,
			searchText: "",
		});
	};

	change = (country: CountryInfo) => {
		const BaseUrl = Host[String(Constant.isUat)];
		const domain = Constant.isDev ? "" : BaseUrl.domain;
		const cookieLocal = comCookieLocal([
			Constant.language,
			country.countryIsoCode2,
			country.defaultCurrency,
		]);
		setCookie("local", cookieLocal, "/", domain);

		setCookie("ci-country", country.countryId, "/", domain);
		// 切换国家时，切换对应的货币
		setCookie("ci-currency", country.defaultCurrency || "USD", "/", domain);

		location.reload();
	};

	render() {
		const { showCancel, searchText, allCountry, filterList } = this.state;
		const { stateChange, currentCountry, popularCountries, countries } = this.props;
		return (
			<Container>
				<Header>
					<Close onClick={() => stateChange("showCountryModal", false)}>
						<img src={AssetImageUrl["ic_back@3x.png"]} width={24} />
					</Close>
					<Title>{gettext("Ship to")}</Title>
				</Header>
				<Search>
					<SearchInput>
						<input
							value={searchText}
							placeholder={gettext("Search")}
							onFocus={() => this.setState({ showCancel: true })}
							onChange={this.searchInput}
						/>
						<img src={AssetImageUrl["ic_search@3x.png"]} width={18} />
					</SearchInput>
					{showCancel && <Cancel onClick={this.cancel}>Cancel</Cancel>}
				</Search>
				<List>
					<div>
						<CountryTitle>{gettext("Current Country")}</CountryTitle>
						<CountryItem noBorderBottom={true} checked={true}>
							<ItemLeft>
								<CountryIcon
									style={{
										backgroundPosition:
											CountryIConPosition[currentCountry?.countryIsoCode2],
									}}
								/>
								<span>{currentCountry.countryName}</span>
							</ItemLeft>
							<img src={AssetImageUrl["ic_right@3x.png"]} width={24} />
						</CountryItem>
						<CountryTitle>{gettext("Popular Country")}</CountryTitle>
						{popularCountries.map((item, index) => {
							return (
								<CountryItem
									key={item.countryId}
									noBorderBottom={index === popularCountries.length - 1}
									onClick={() => this.change(item)}
								>
									<ItemLeft>
										<CountryIcon
											style={{
												backgroundPosition:
													CountryIConPosition[item.countryIsoCode2],
											}}
										/>
										<span>{item.countryName}</span>
									</ItemLeft>
									<img src={AssetImageUrl["ic_right@3x.png"]} width={24} />
								</CountryItem>
							);
						})}
						{countries.map((item, index) => {
							// 英语时才显示首字母分组
							if (Constant.language === "en") {
								let hasTitle = false;
								let nextFirstLetter = "";
								if (
									item &&
									item.countryName &&
									allCountry[index + 1] &&
									allCountry[index + 1].countryName
								) {
									const currentFirstLetter = item.countryName[0];
									nextFirstLetter = allCountry[index + 1].countryName[0];
									if (currentFirstLetter !== nextFirstLetter) {
										hasTitle = true;
									}
								}
								return (
									<React.Fragment key={item.countryId}>
										{index === 0 ? (
											<LetterTitle>{nextFirstLetter}</LetterTitle>
										) : null}
										<CountryItem
											noBorderBottom={hasTitle}
											onClick={() => this.change(item)}
										>
											<ItemLeft>
												<CountryIcon
													style={{
														backgroundPosition:
															CountryIConPosition[
																item.countryIsoCode2
															],
													}}
												/>
												<span>{item.countryName}</span>
											</ItemLeft>
											<img
												src={AssetImageUrl["ic_right@3x.png"]}
												width={24}
											/>
										</CountryItem>
										{hasTitle ? (
											<LetterTitle>{nextFirstLetter}</LetterTitle>
										) : null}
									</React.Fragment>
								);
							} else {
								return (
									<React.Fragment key={item.countryId}>
										<CountryItem onClick={() => this.change(item)}>
											<ItemLeft>
												<CountryIcon
													style={{
														backgroundPosition:
															CountryIConPosition[
																item.countryIsoCode2
															],
													}}
												/>
												<span>{item.countryName}</span>
											</ItemLeft>
											<img
												src={AssetImageUrl["ic_right@3x.png"]}
												width={24}
											/>
										</CountryItem>
									</React.Fragment>
								);
							}
						})}
					</div>
				</List>
				{!!searchText && searchText.length > 0 && (
					<List>
						{filterList.map((item) => {
							return (
								<CountryItem
									key={item.countryId}
									noBorderBottom={false}
									onClick={() => this.change(item)}
								>
									<ItemLeft>
										<CountryIcon
											style={{
												backgroundPosition:
													CountryIConPosition[item.countryIsoCode2],
											}}
										/>
										<span>{item.countryName}</span>
									</ItemLeft>
									<img src={AssetImageUrl["ic_right@3x.png"]} width={24} />
								</CountryItem>
							);
						})}
					</List>
				)}
			</Container>
		);
	}
}

export default Country;
